'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calculateDocumentModeOrder = undefined;

var _elementDataPreprocessor = require('./elementDataPreprocessor');

var _documentOrderDataBuilder = require('../../../../common/documentOrder/documentOrderDataBuilder');

var _documentModeDebugger = require('./documentModeDebugger');

var processDocumentElements = function processDocumentElements(_ref) {
    var documentElements = _ref.documentElements;

    var documentModeData = (0, _documentModeDebugger.debugDocumentModeWrapper)(_documentOrderDataBuilder.buildDocumentModeData)(documentElements);

    return {
        order: (0, _documentOrderDataBuilder.collapseDocumentElementOrder)(documentModeData),
        details: documentModeData
    };
}; // Utils
var calculateDocumentModeOrder = exports.calculateDocumentModeOrder = function calculateDocumentModeOrder(_ref2) {
    var elements = _ref2.elements,
        elementSizes = _ref2.elementSizes;

    var documentElements = (0, _elementDataPreprocessor.preprocessElementData)(elements, elementSizes);
    return processDocumentElements({ documentElements: documentElements });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/algorithm/documentModeUtil.js
// module id = 2206
// module chunks = 0